import styled, { css } from 'styled-components';

export const ToastWrapper = styled.div`
  position: fixed;
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 999;
  justify-content: center;
  min-width: 260px;
  max-width: 500px;
  ${({ type }) => type === 'simple' && css`
    top: 70px;
    left:50%;
    margin-left: -110px
  `}

  ${({ type }) => type === 'sticky' && css`
    bottom: 14px;
  `}
`;

export const ToastItem = styled.div`
  padding: 10px 38px;
  display: block;
  width: auto;
  transition: all 0.3s cubic-bezier(0.4, 0.0, 0.2, 1);

  /* simple toast animation | position : top-center */
    &.simple-enter {
      opacity: 0.01;
      transform: translateY(-50px);
  }
    &.simple-enter-active {
        opacity: 1;
        transform: translateY(0px);
  }
    &.simple-exit {
        opacity: 1;
        transform: translateY(-15px);
  }
    &.simple-exit-active {
        opacity: 0.01;
        transform: translateY(0px);
   }

  /* sticky toast animation | position: bottom-left*/
   &.sticky-enter {
      opacity: 0.01;
      transform: translateX(-40px)
  }
    &.sticky-enter-active {
        opacity: 1;
        transform: translateX(0px);
  }
    &.sticky-exit {
        opacity: 1;
        transform: translateX(40px)
  }
    &.sticky-exit-active {
        opacity: 0.01;
        transform: translateX(0px);
   }
`;
